import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { KeywordHighlightModel } from '../../Misc/models/keyword-highlight.model';
import { FilterService } from '../../Filter/services/abstract-filter.service';


@Injectable()
export class MentionSearchVarsService extends FilterService {

    protected highlightKeywords: KeywordHighlightModel[] = null;
    protected highlightKeywords$: BehaviorSubject<KeywordHighlightModel[]> = new BehaviorSubject<KeywordHighlightModel[]>(this.highlightKeywords);

    constructor() {
        super();
    }

    /**
     * Gets the include keywords
    */
    public getHighlightKeywords(): Observable<KeywordHighlightModel[]> {
        return this.highlightKeywords$;
    }
}
